import common from './common.json';
import components from './components.json';

export default {
  components,
  common,
};
